import {Component, OnInit} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core"
import {NavbarComponent} from "../../components/navbar/navbar.component";
import {VisitorFormDto} from "./contracts/visitor-form.dto";
import {FormsModule} from "@angular/forms";
import {DatePickerCmp} from "../../components/inputs/date-picker/date-picker.cmp";
import {NgIf} from "@angular/common";
import {SignaturePadPage} from "../../components/inputs/sig-pad/sig-pad.cmp";
import {VisitorsService} from "./visitors.service";
import {AppFormCheckCmp} from "../../components/inputs/app-form-check/app-form-check.cmp";

@Component({
    selector: 'app-visitors',
    standalone: true,
    imports: [TranslateModule, NavbarComponent, NavbarComponent, FormsModule, DatePickerCmp, NgIf, SignaturePadPage, AppFormCheckCmp],
    templateUrl: './visitors.cmp.html'
})

export class VisitorsComponent implements OnInit {
    model: VisitorFormDto = new VisitorFormDto();
    saving: boolean;
    checkedIn: boolean;

    constructor(private visitorService: VisitorsService) {
    }

    ngOnInit() {
        this.model.entryHour = new Date();
        this.model.stayUntilDayEnd = true;
    }

    checkAndSetExitHour() {
        let eod = this.model.exitHour;
        if (!this.model.exitHour) {
            eod = new Date();
            eod.setHours(18, 0, 0);
        }
        if (eod < this.model.entryHour) {
            eod = this.model.entryHour;
        }
        this.model.exitHour = eod;
    }

    changeStayUntilDayEnd(value: boolean) {
        this.model.stayUntilDayEnd = value;
        this.checkAndSetExitHour();
    }

    changeEntryHour($event: Date) {
        this.model.entryHour = $event;
        this.checkAndSetExitHour();
    }

    isValid() {
        if (!this.model.entryHour) return false;
        if (!this.model.firstName) return false;
        if (!this.model.lastName) return false;
        if (!this.model.reasonForVisiting) return false;
        if (!this.model.contactPerson) return false;
        if (!this.model.idDetails) return false;
        if (!this.model.cardAccess) return false;
        if (!this.model.signature) return false;

        return true;
    }

    async submit() {
        if (!this.isValid()) return;
        await this.visitorService.submit(this.model);
        this.checkedIn = true;
        window.scrollTo(0, 0);
    }
}
